import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchOffboardingTableAndFilterSchema } from "model/OffboardingModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const OffboardingContext = createContext();

export const OffboardingProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [offboardingContextData, setOffboardingContextData] = useState();

  const fetchOffboardingContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:offboarding", () =>
        fetchOffboardingTableAndFilterSchema([])
      );
      if (response?.success) {
        setOffboardingContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch offboarding metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <OffboardingContext.Provider
      value={{
        fetchOffboardingContextData,
        offboardingContextData,
        loading,
        error,
      }}
    >
      {children}
    </OffboardingContext.Provider>
  );
};

export const useOffboardingContext = () => useContext(OffboardingContext);
